import {
  BATCHES_DEBOUNCE_MS as DEBOUNCE_MS,
  BATCHES_EXPORT_POLL_INTERVAL_MS as EXPORT_POLL_INTERVAL_MS,
  BATCHES_EXPORT_MAX_POLLS as EXPORT_MAX_POLLS,
} from "../../../constants/analyticsBatches";

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadcrumbHeader from "../../../components/Header/BreadCrumHeader.jsx";
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import ListCard from "../../../components/Card/ListCardDetails.jsx";
import DownloadAll from "./DownlaodAllFilter.jsx";
import {
  Box,
  Grid,
  InputAdornment,
  OutlinedInput,
  CircularProgress,
  Button,
  TextField,
  Divider,
  IconButton,
  MenuItem,
  Select,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DownloadIcon from "@mui/icons-material/Download";

import DropdownsBar from "../header/ProductSiteUnitSelector.jsx";
import TabsBar from "../header/TabsNav.jsx";
import BreadcrumbsBar from "../header/BreadcrumbNav.jsx";

import BatchesTable from "./batchesTable/BatchesTable.jsx";
import PartialDataTable from "./partialDataTable/PartialDataTable.jsx";

import {
  downloadBatchesData,
  exportPartialBatches,
  fetchBatches,
  fetchPartialBatches,
  getPartialBatchesExportStatus,
  resetPartialBatches,
  resetDownloadBatchesData,
  getBatchDetails,
} from "../../../redux/batches/actions.js";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import Pagination from "../../../components/Pagination/index";

import "./batches.scss";
import BatchFilters from "./batchFilters.jsx/index.jsx";
import Label from "../../../components/Label/Label.jsx";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DatePicker from "react-datepicker";
import ClearIcon from "@mui/icons-material/Clear";
import BatchDetailsTable from "./BatchDetailsTable.jsx";
import { set } from "date-fns";
import * as types from "../../../redux/batches/types.js";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { AddBox } from "@mui/icons-material";
import Loader from "../../../components/Loader/loader.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { manageDataRoute } from "../../../routes/routeConstants.js";
import { setProductSitesUopFilters } from "../../../redux/shared/actions.js";
import { hasPermission } from "../../../utils/permissions.js";
import {
  BATCHES_PERMISSIONS,
  MANAGE_DATA_MODULE,
  MANAGE_DATA_PERMISSIONS,
  PERMISSION_MODULES,
} from "../../../constants/permissions";

import {
  isTruthyFlag,
  MANAGE_DATA_PERMISSION_DENIED_MESSAGE,
  MIGRATED_BATCH_REDIRECT_MESSAGE,
} from "../../../utils/batchesUtility.js";

const Batches = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const restoredPartialState = location.state?.partialBatchesPageState;
  const canViewBatches = hasPermission(
    PERMISSION_MODULES.BATCHES,
    BATCHES_PERMISSIONS.VIEW_BATCH_LIST,
  );
  const canViewPartialData = hasPermission(
    PERMISSION_MODULES.BATCHES,
    BATCHES_PERMISSIONS.PARTIAL_DATA_TAB,
  );
  const canDownloadPartialData = hasPermission(
    PERMISSION_MODULES.BATCHES,
    BATCHES_PERMISSIONS.DOWNLOAD_PARTIAL_DATA,
  );
  const canDownloadBatches = hasPermission(
    PERMISSION_MODULES.BATCHES,
    BATCHES_PERMISSIONS.DOWNLOAD_BATCHES,
  );
  const canViewMetaData = hasPermission(
    PERMISSION_MODULES.BATCHES,
    BATCHES_PERMISSIONS.VIEW_META_DATA,
  );
  const canViewManageDataReviewList = hasPermission(
    MANAGE_DATA_MODULE,
    MANAGE_DATA_PERMISSIONS.VIEW_BATCH_LIST,
  );

  const {
    product = { id: "", name: "" },
    site = { id: "", name: "" },
    unitOfOperation = { id: "", name: "" },
  } = useSelector((state) => state.shared.productSitesUopValues || {});

  const batchesSlice = useSelector((state) => state.batch?.batches || {});
  const partialBatchesSlice = useSelector(
    (state) => state.batch?.partialBatches || {},
  );
  const batchDetails = useSelector((state) => state.batch?.batchDetails || {});
  const downloadedBatchesData = useSelector(
    (state) => state.batch?.downloadedBatchesData || {},
  );

  const { data: batchesData = {}, loader = false } = batchesSlice;
  const {
    data: partialBatchesData = {},
    loader: partialBatchesLoader = false,
    apiError: partialBatchesError = false,
    message: partialBatchesMessage = "",
  } = partialBatchesSlice;

  const {
    results: resultsFromStore = [],
    total: totalCount = 0,
    page: currentPageFromStore = 1,
    page_size: pageSizeFromStore = 50,
    total_pages: totalPagesFromStore = 0,
  } = batchesData;

  const {
    results: partialResults = [],
    total: partialTotalCount = 0,
    page: partialCurrentPage = 1,
    page_size: partialPageSize = 50,
    total_pages: partialTotalPages = 0,
  } = partialBatchesData;
  const [page, setPage] = useState(
    restoredPartialState?.page || currentPageFromStore || 1,
  );
  const [rowsPerPage] = useState(pageSizeFromStore || 50);
  const [search, setSearch] = useState(restoredPartialState?.search || "");
  const [debouncedSearch, setDebouncedSearch] = useState(
    restoredPartialState?.debouncedSearch || "",
  );
  const [selectedBatchIds, setSelectedBatchIds] = useState([]);
  const [viewLogs, setViewLogs] = useState(false);
  const [batchTableData, setBatchTableData] = useState([]);
  const [batchID, setBatchId] = useState();
  const [viewDataIsPartialBatch, setViewDataIsPartialBatch] = useState(false);
  const [downloadAll, setDownloadAll] = useState(false);
  const [activeSection, setActiveSection] = useState(
    restoredPartialState?.activeSection === "partial" && canViewPartialData
      ? "partial"
      : canViewBatches
        ? "batches"
        : canViewPartialData
          ? "partial"
          : "batches",
  );
  const [selectedPartialUnitOperations, setSelectedPartialUnitOperations] =
    useState(restoredPartialState?.selectedUnitOperations || []);
  const [batchesListSelection, setBatchesListSelection] = useState(
    restoredPartialState?.batchesListSelection || {
      unitOperation: unitOfOperation,
      productId: product?.id,
      siteId: site?.id,
    },
  );
  const [partialSortConfig, setPartialSortConfig] = useState(
    restoredPartialState?.sortConfig || {
      sort_by: "",
      sort_order: "asc",
    },
  );
  const [partialDownloadLoading, setPartialDownloadLoading] = useState(false);
  const partialExportCancelledRef = useRef(false);
  const previousSearchRef = useRef(search);

  useEffect(() => {
    if (!canViewPartialData && activeSection === "partial") {
      setActiveSection("batches");
      setPage(1);
      setSelectedPartialUnitOperations([]);
      dispatch(resetPartialBatches());
    }
    if (!canViewBatches && activeSection === "batches" && canViewPartialData) {
      setActiveSection("partial");
      setPage(1);
    }
  }, [activeSection, canViewBatches, canViewPartialData, dispatch]);

  const batchesListUnitOperation =
    batchesListSelection.productId === product?.id &&
    batchesListSelection.siteId === site?.id
      ? batchesListSelection.unitOperation
      : null;

  useEffect(() => {
    if (activeSection !== "batches" || !unitOfOperation?.id) return;

    setBatchesListSelection({
      unitOperation: unitOfOperation,
      productId: product?.id,
      siteId: site?.id,
    });
  }, [
    activeSection,
    product?.id,
    site?.id,
    unitOfOperation?.id,
    unitOfOperation?.name,
  ]);

  useEffect(() => {
    partialExportCancelledRef.current = false;
    return () => {
      partialExportCancelledRef.current = true;
    };
  }, []);

  // Debounce search (wait after user stops typing)
  useEffect(() => {
    if (previousSearchRef.current === search) {
      return undefined;
    }
    previousSearchRef.current = search;

    const handler = setTimeout(() => {
      setDebouncedSearch(search?.trim());
      // Reset to first page when the query meaningfully changes
      setPage(1);
    }, DEBOUNCE_MS);
    return () => clearTimeout(handler);
  }, [search]);

  // const formatDate = useCallback((date) => {
  //   if (!date) return null;
  //   const d = new Date(date);
  //   // Normalize to YYYY-MM-DD to match typical API expectations
  //   return d.toISOString().split("T")[0];
  // }, []);

  const formatDate = useCallback((date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }, []);

  const getDefaultDates = useCallback(() => {
    const now = "";
    const startDate = "";
    // startDate.setMonth(now.getMonth() - 3); // subtract 3 months
    return { startDate, endDate: now };
  }, []);

  const [batchState, setBatchState] = useState({
    ...(restoredPartialState?.batchState || getDefaultDates()),
    // metaDataStatus: "all",
    // batchStatus: "all",
  });

  // const [filterOpen, setFilterOpen] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  // Build payload from current local state.
  const buildPayload = useCallback(
    (pageArg = 1, searchArg = debouncedSearch, dates = batchState) => ({
      page: pageArg,
      page_size: rowsPerPage,
      unit_of_operation: unitOfOperation.id || undefined,
      // metadata_status: "approved",
      // batch_status: "Completed",
      from_date: formatDate(dates.startDate),
      to_date: formatDate(dates.endDate),
      search: searchArg || undefined,
    }),
    [rowsPerPage, unitOfOperation?.id, debouncedSearch, batchState, formatDate],
  );

  const buildPartialPayload = useCallback(
    (pageArg = 1, searchArg = debouncedSearch, dates = batchState) => ({
      page: pageArg,
      page_size: rowsPerPage,
      unit_op_ids: selectedPartialUnitOperations
        .map((item) => item.id)
        .join(","),
      search: searchArg || undefined,
      from_date: formatDate(dates.startDate),
      to_date: formatDate(dates.endDate),
      sort_by: partialSortConfig.sort_by || undefined,
      sort_order: partialSortConfig.sort_by
        ? partialSortConfig.sort_order
        : undefined,
    }),
    [
      rowsPerPage,
      selectedPartialUnitOperations,
      debouncedSearch,
      batchState,
      formatDate,
      partialSortConfig,
    ],
  );
  // Initial fetch (on mount only)
  useEffect(() => {
    dispatch({ type: types.CLEAR_ROW });
    if (canViewBatches && activeSection === "batches" && unitOfOperation?.id) {
      dispatch(fetchBatches(buildPayload(1)));
    }
    setPage(restoredPartialState?.page || 1);
    setViewLogs(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Refetch when page or debouncedSearch changes.
  // IMPORTANT: We intentionally do NOT depend on `batchState` here,
  // so changing date range does not auto-fetch until user clicks "Search".
  useEffect(() => {
    if (!canViewBatches || activeSection !== "batches") return;
    const payload = buildPayload(page);
    if (unitOfOperation?.id) {
      dispatch(fetchBatches(payload));
    }
    setViewLogs(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    page,
    debouncedSearch,
    rowsPerPage,
    unitOfOperation?.id,
    activeSection,
    dispatch,
    canViewBatches,
  ]);

  useEffect(() => {
    if (!canViewPartialData || activeSection !== "partial") return;
    if (!unitOfOperation?.id) return;
    if (!selectedPartialUnitOperations.length) return;
    dispatch(fetchPartialBatches(buildPartialPayload(page)));
    setViewLogs(false);
  }, [
    activeSection,
    page,
    debouncedSearch,
    selectedPartialUnitOperations,
    unitOfOperation?.id,
    partialSortConfig,
    dispatch,
    canViewPartialData,
  ]);

  useEffect(() => {
    if (!canViewPartialData || activeSection !== "partial" || unitOfOperation?.id) return;

    setSelectedPartialUnitOperations([]);
    dispatch(resetPartialBatches());
    setSnackbar({
      open: true,
      message: "Please select a unit operation in Batches first.",
      severity: "warning",
    });
  }, [activeSection, canViewPartialData, dispatch, unitOfOperation?.id]);

  useEffect(() => {
    if (partialBatchesError) {
      setSnackbar({
        open: true,
        message: partialBatchesMessage || "Unable to load partial batches",
        severity: "error",
      });
    }
  }, [partialBatchesError, partialBatchesMessage]);
  // Reset selection when result set changes to avoid stale selections
  useEffect(() => {
    setSelectedBatchIds([]);
  }, [resultsFromStore]);

  // Handle download success
  useEffect(() => {
    if (downloadedBatchesData?.success && downloadedBatchesData?.data) {
      if (downloadedBatchesData?.success) {
        setSnackbar({
          open: true,
          message: "Success",
          severity: "success",
        });
        const a = document.createElement("a");
        const url = downloadedBatchesData.data.data.download_url;
        a.href = url;
        a.click();
        URL.revokeObjectURL(url);
      } else if (downloadedBatchesData?.message) {
        setSnackbar({
          open: true,
          message: downloadedBatchesData?.message,
          severity: "error",
        });
      }
    }
    setTimeout(() => {
      dispatch(resetDownloadBatchesData());
    }, 2000);
  }, [
    downloadedBatchesData?.success,
    downloadedBatchesData?.data,
    downloadedBatchesData?.file_name,
    dispatch,
  ]);

  // Handle download error
  useEffect(() => {
    if (downloadedBatchesData?.apiError) {
      setSnackbar({
        open: true,
        message: downloadedBatchesData?.message || "Download failed",
        severity: "error",
      });
      dispatch(resetDownloadBatchesData());
    }
  }, [
    downloadedBatchesData?.apiError,
    downloadedBatchesData?.message,
    dispatch,
  ]);

  const updateState = useCallback(
    (key, value) => setBatchState((prev) => ({ ...prev, [key]: value })),
    [],
  );

  const handleSearch = useCallback(() => {
    setPage(1);
    if (activeSection === "partial") {
      if (!canViewPartialData) return;
      if (!selectedPartialUnitOperations.length) {
        setSnackbar({
          open: true,
          message: "unit_op_ids is required",
          severity: "warning",
        });
        return;
      }
      dispatch(fetchPartialBatches(buildPartialPayload(1)));
    } else {
      if (!canViewBatches) return;
      dispatch(fetchBatches(buildPayload(1)));
    }
    setViewLogs(false);
  }, [
    activeSection,
    dispatch,
    buildPayload,
    buildPartialPayload,
    canViewBatches,
    canViewPartialData,
  ]);

  const handleResetFilters = useCallback(() => {
    const reset = {
      ...getDefaultDates(),
      // batchValueStatus: "all",
      // metaDataStatus: "all",
      // batchStatus: "all",
    };
    setBatchState(reset);
    setSearch("");
    setDebouncedSearch("");
    setPage(1);
    if (activeSection === "partial") {
      if (!canViewPartialData) return;
      if (!selectedPartialUnitOperations.length) {
        setSnackbar({
          open: true,
          message: "unit_op_ids is required",
          severity: "warning",
        });
        return;
      }
      dispatch(
        fetchPartialBatches({
          ...buildPartialPayload(1, "", reset),
          from_date: formatDate(reset.startDate),
          to_date: formatDate(reset.endDate),
        }),
      );
    } else {
      if (!canViewBatches) return;
      dispatch(
        fetchBatches({
          ...buildPayload(1, ""),
          from_date: formatDate(reset.startDate),
          to_date: formatDate(reset.endDate),
        }),
      );
    }
    setViewLogs(false);
  }, [
    activeSection,
    selectedPartialUnitOperations.length,
    dispatch,
    buildPayload,
    buildPartialPayload,
    getDefaultDates,
    formatDate,
    canViewBatches,
    canViewPartialData,
  ]);

  const handleSearchChange = useCallback((e) => {
    setSearch(e.target.value);
  }, []);

  const onClickDownload = useCallback(() => {
    if (!canDownloadBatches) return;
    if (!unitOfOperation?.id) {
      return setSnackbar({
        open: true,
        message: "Please select a unit operation first.",
        severity: "warning",
      });
    }
    if (!selectedBatchIds?.length > 0) {
      setSnackbar({
        open: true,
        message: "Please select at least one batch to download.",
        severity: "warning",
      });
      return;
    }
    if (downloadedBatchesData?.loader) return; // guard against double-clicks
    dispatch(
      downloadBatchesData({
        batch_ids: selectedBatchIds,
        unit_op_id: unitOfOperation?.id,
      }),
    );
  }, [
    canDownloadBatches,
    dispatch,
    selectedBatchIds,
    downloadedBatchesData?.loader,
    unitOfOperation?.id,
  ]);

  const totalPages = useMemo(() => {
    if (activeSection === "partial") {
      return (
        partialTotalPages ||
        Math.max(1, Math.ceil(partialTotalCount / partialPageSize))
      );
    }
    return (
      totalPagesFromStore || Math.max(1, Math.ceil(totalCount / rowsPerPage))
    );
  }, [
    activeSection,
    partialTotalPages,
    partialTotalCount,
    partialPageSize,
    totalPagesFromStore,
    totalCount,
    rowsPerPage,
  ]);

  // Enter to trigger search
  const searchInputRef = useRef(null);
  const onSearchKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        handleSearch();
      }
    },
    [handleSearch],
  );

  // Stable prop object for table to reduce re-renders
  const stableBatchesState = useMemo(
    () => ({
      ...batchesSlice,
      data: {
        ...batchesData,
        results: resultsFromStore,
        page: currentPageFromStore,
        page_size: pageSizeFromStore,
        total_pages: totalPagesFromStore,
      },
    }),
    [batchesSlice, batchesData, resultsFromStore],
  );

  const viewAuditLogs = () => {
    setViewLogs(!viewLogs);
  };

  const handleViewDetails = (type, data) => {
    if (!canViewMetaData) return;
    setBatchId(data?.batch_id);
    setViewDataIsPartialBatch(isTruthyFlag(data?.is_partial_batch));
    setViewLogs(!viewLogs);
    setBatchTableData();
    dispatch(
      getBatchDetails({
        batch_id: data?.batch_id,
        unit_op_id: unitOfOperation.id,
      }),
    );
  };

  const handlePartialBatchClick = useCallback(
    (row) => {
      if (!row?.batch_id) return;
      if (!canViewManageDataReviewList) {
        setSnackbar({
          open: true,
          message: MANAGE_DATA_PERMISSION_DENIED_MESSAGE,
          severity: "warning",
        });
        return;
      }
      if (!canViewMetaData) return;
      if (isTruthyFlag(row.is_migrated_batch)) {
        setSnackbar({
          open: true,
          message: MIGRATED_BATCH_REDIRECT_MESSAGE,
          severity: "warning",
        });
        return;
      }

      const rowUnitOperationId = row.unit_op_id || row.unit_operation_id;
      const rowUnitOperationName = row.unit_operation || row.step_name;
      const matchedUnitOperation = selectedPartialUnitOperations.find(
        (item) =>
          (rowUnitOperationId && item.id === rowUnitOperationId) ||
          (rowUnitOperationName && item.name === rowUnitOperationName),
      );

      const targetUnitOperation = matchedUnitOperation ||
        (rowUnitOperationId
          ? { id: rowUnitOperationId, name: rowUnitOperationName || "" }
          : null);

      if (!targetUnitOperation?.id) {
        setSnackbar({
          open: true,
          message: "Unable to locate this batch because its unit operation is missing.",
          severity: "error",
        });
        return;
      }

      dispatch(
        setProductSitesUopFilters({
          product,
          site,
          unitOfOperation: targetUnitOperation,
        }),
      );
      const returnPageState = {
        activeSection: "partial",
        highlightedBatchId: row.batch_id,
        page,
        search,
        debouncedSearch,
        batchState,
        sortConfig: partialSortConfig,
        batchesListSelection,
        selectedUnitOperations: selectedPartialUnitOperations,
      };
      const restoredLocationState = {
        ...location.state,
        partialBatchesPageState: returnPageState,
      };

      navigate(location.pathname + location.search, {
        replace: true,
        state: restoredLocationState,
      });
      navigate(`/${manageDataRoute.reviewBatches}`, {
        state: {
          batchId: row.batch_id,
          unitOfOperation: targetUnitOperation,
          site,
          product,
          backButtonText: "Back to Batches",
          backTo: {
            pathname: location.pathname,
            search: location.search,
            state: restoredLocationState,
          },
        },
      });
    },
    [
      canViewMetaData,
      canViewManageDataReviewList,
      batchState,
      batchesListSelection,
      debouncedSearch,
      dispatch,
      location.pathname,
      location.search,
      location.state,
      navigate,
      page,
      partialSortConfig,
      product,
      search,
      selectedPartialUnitOperations,
      site,
    ],
  );

  const handlePartialSort = useCallback((sortBy) => {
    setPage(1);
    setPartialSortConfig((current) => ({
      sort_by: sortBy,
      sort_order:
        current.sort_by === sortBy && current.sort_order === "asc"
          ? "desc"
          : "asc",
    }));
  }, []);

  useEffect(() => {
    if (batchDetails?.data && batchDetails?.data?.length > 0) {
      setBatchTableData(batchDetails?.data[0] || []);
    }
  }, [batchDetails?.data]);

  const handlePartialDownload = useCallback(async () => {
    if (!canViewPartialData || !canDownloadPartialData) return;
    const unitOperationIds = selectedPartialUnitOperations
      .map((item) => item?.id)
      .filter(Boolean);

    if (!unitOperationIds.length) {
      setSnackbar({
        open: true,
        message: "Please select at least one unit operation to download.",
        severity: "warning",
      });
      return;
    }
    if (partialDownloadLoading) return;

    setPartialDownloadLoading(true);
    try {
      const exportResponse = await dispatch(
        exportPartialBatches(unitOperationIds),
      );
      const taskId = exportResponse?.data?.data?.task_id;
      if (!exportResponse?.data?.status || !taskId) {
        throw new Error(
          exportResponse?.data?.message || "Unable to queue partial data export.",
        );
      }

      for (let poll = 0; poll < EXPORT_MAX_POLLS; poll += 1) {
        if (partialExportCancelledRef.current) return;
        if (poll > 0) {
          await new Promise((resolve) =>
            setTimeout(resolve, EXPORT_POLL_INTERVAL_MS),
          );
        }
        if (partialExportCancelledRef.current) return;

        const statusResponse = await dispatch(
          getPartialBatchesExportStatus(taskId),
        );
        const responseData = statusResponse?.data;
        const exportData = responseData?.data || {};
        const taskStatus = exportData.task_status?.toUpperCase();

        if (taskStatus === "SUCCESS") {
          if (!exportData.download_url) {
            throw new Error("Export completed without a download URL.");
          }
          const link = document.createElement("a");
          link.href = exportData.download_url;
          link.download = "partial_batches_export.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setSnackbar({
            open: true,
            message: `Partial data export completed${
              exportData.record_count != null
                ? ` (${exportData.record_count} records)`
                : ""
            }.`,
            severity: "success",
          });
          return;
        }

        if (["FAILURE", "FAILED", "REVOKED"].includes(taskStatus)) {
          throw new Error(responseData?.message || "Partial data export failed.");
        }
      }

      throw new Error("Partial data export timed out. Please try again.");
    } catch (error) {
      if (!partialExportCancelledRef.current) {
        setSnackbar({
          open: true,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Unable to download partial data.",
          severity: "error",
        });
      }
    } finally {
      if (!partialExportCancelledRef.current) {
        setPartialDownloadLoading(false);
      }
    }
  }, [
    canDownloadPartialData,
    canViewPartialData,
    dispatch,
    partialDownloadLoading,
    selectedPartialUnitOperations,
  ]);

  const handleDownloadAll = () => {
    if (!canDownloadBatches) return;
    setDownloadAll(true);
  };
  return (
    <div>
      <CAMHeader />
      <CAMDrawer />

      <InvestigatorContainer>
        <TabsBar />
        <DropdownsBar
          unitOperationMultiple={activeSection === "partial"}
          selectedUnitOperations={selectedPartialUnitOperations}
          onUnitOperationsChange={(unitOperations) => {
            setSelectedPartialUnitOperations(unitOperations);
            setPage(1);
          }}
        />

        {/* <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} md={6}>
          </Grid>
        </Grid> */}

        <Divider sx={{ mx: 2 }} />
        <Box sx={{ py: 0.5 }}>
          <BreadcrumbsBar
            sectionLabel={
              activeSection === "partial" ? "Partial Data" : undefined
            }
            selectedUnitOperations={
              activeSection === "partial"
                ? selectedPartialUnitOperations
                : undefined
            }
          />
        </Box>
        <Divider sx={{ mx: 2 }} />

        <Box>
          {/* {filterOpen && (
              <Grid item xs={2.5} className="batch-filter-panel">
                <Box className="filter-card-wrapper">
                  <Box className="filter-scrollable-panel">
                    <BatchFilters
                      batchState={batchState}
                      updateState={updateState}
                      handleClearAll={handleResetFilters}
                      handleApply={handleSearch}
                      setFilterOpen={setFilterOpen}
                    />
                  </Box>
                </Box>
              </Grid>
            )} */}

          <Box>
            {/* Toolbar */}

            {/* Table Section */}
            {viewLogs && (
              <>
                <Box
                  mt={1}
                  mb={2}
                  gap={2}
                  display={"flex"}
                  flexDirection={"column"}
                >
                  <BreadcrumbHeader
                    text={""}
                    onBackClick={() => setViewLogs(false)}
                  />
                </Box>
              </>
            )}
            <Box>
              <Box>
                {viewLogs ? (
                  <>
                    <Box
                      display={"flex"}
                      gap={2}
                      flexDirection={"row"}
                      height={"calc(100vh - 235px)"}
                    >
                      <ListCard
                        openData={batchTableData}
                        batchID={batchID}
                        data={batchDetails}
                        handleMenuClick={(e) => setBatchTableData(e)}
                      />
                      <BatchDetailsTable
                        data={batchTableData}
                        batchDetails={batchDetails}
                        isPartialBatch={viewDataIsPartialBatch}
                      />
                    </Box>
                  </>
                ) : (
                  <>
                    <Box
                      className="batches-toolbar"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >

                      {/* Search */}
                      <OutlinedInput
                        inputRef={searchInputRef}
                        size="small"
                        showYearDropdown
                        placeholder="Search Batch ID"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={onSearchKeyDown}
                        sx={{
                          width: 240,
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                        }}
                        startAdornment={
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                          </InputAdornment>
                        }
                      />

                      {/* Divider with some spacing */}
                      <Divider orientation="vertical" flexItem sx={{ my: 1 }} />

                      {/* Date Range */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          p: 0.5,
                          borderRadius: "8px",
                          background: "#e9e9e9ff",
                        }}
                        className="date-range-picker-report"
                      >
                        {[
                          ["startDate", "From"],
                          ["endDate", "To"],
                        ].map(([key, placeholder]) => (
                          <DatePicker
                            key={key}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={50}
                            // popperClassName="custom-datepicker-popper"
                            selected={batchState[key]}
                            onChange={(date) => updateState(key, date)}
                            selectsStart={key === "startDate"}
                            selectsEnd={key === "endDate"}
                            startDate={batchState.startDate}
                            endDate={batchState.endDate}
                            minDate={
                              key === "endDate"
                                ? batchState.startDate || new Date("1900-01-01")
                                : new Date("1900-01-01")
                            }
                            maxDate={new Date()} // keep upper bound at today
                            placeholderText={placeholder}
                            dateFormat="dd-MMM-yyyy"
                            fixedHeight
                            renderCustomHeader={({
                              date,
                              decreaseMonth,
                              increaseMonth,
                              changeYear,
                              prevMonthButtonDisabled,
                              nextMonthButtonDisabled,
                            }) => (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  px: 1.5,
                                  py: 1,
                                  bgcolor: "primary.main",
                                  color: "common.white",
                                  borderRadius: "8px 8px 0 0",
                                }}
                              >
                                <IconButton
                                  onClick={decreaseMonth}
                                  disabled={prevMonthButtonDisabled}
                                  sx={{ color: "common.white", p: 0.5 }}
                                  size="small"
                                >
                                  <ArrowBackIosIcon fontSize="small" />
                                </IconButton>

                                <Box
                                  sx={{
                                    mx: 1,
                                    fontWeight: 500,
                                    cursor: "default",
                                    width: 80,
                                    textAlign: "center",
                                  }}
                                >
                                  <Label
                                    text={date.toLocaleString("default", {
                                      month: "long",
                                    })}
                                    color="#ffff"
                                    fontSize={16}
                                    fontWeight={600}
                                  />
                                </Box>

                                <Select
                                  value={date.getFullYear()}
                                  onChange={(e) =>
                                    changeYear(Number(e.target.value))
                                  }
                                  size="small"
                                  onMouseDown={(e) => e.stopPropagation()} // prevent closing
                                  onClick={(e) => e.stopPropagation()} // prevent closing
                                  sx={{
                                    fontSize: 13,
                                    color: "text.primary",
                                    bgcolor: "background.paper",
                                    borderRadius: 1,
                                    // "& .MuiSelect-select": {
                                    //   py: 0.25,
                                    //   px: 1,
                                    // },
                                  }}
                                >
                                  {Array.from(
                                    { length: 50 },
                                    (_, i) => new Date().getFullYear() - i,
                                  ).map((y) => (
                                    <MenuItem key={y} value={y}>
                                      {y}
                                    </MenuItem>
                                  ))}
                                </Select>

                                <IconButton
                                  onClick={increaseMonth}
                                  disabled={nextMonthButtonDisabled}
                                  sx={{ color: "common.white", p: 0.5 }}
                                  size="small"
                                >
                                  <ArrowForwardIosIcon fontSize="small" />
                                </IconButton>
                              </Box>
                            )}
                            customInput={
                              <TextField
                                size="small"
                                sx={{
                                  width: 160,
                                  backgroundColor: "#fff",
                                  borderRadius: "6px",
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <CalendarTodayIcon fontSize="small" />
                                    </InputAdornment>
                                  ),
                                  readOnly: true,
                                }}
                              />
                            }
                          />
                        ))}

                        <Button
                          onClick={handleSearch}
                          variant="contained"
                          sx={{
                            textTransform: "none",
                            backgroundColor: "#3882DB",
                            "&:hover": { backgroundColor: "#1565c0" },
                            minHeight: "36px",
                          }}
                        >
                          <Label text="Search" color="#fff" />
                        </Button>
                      </Box>

                      <Button
                        onClick={handleResetFilters}
                        variant="outlined"
                        sx={{ textTransform: "none", minHeight: "36px" }}
                        startIcon={<ClearIcon />}
                      >
                        <Label text="Reset" />
                      </Button>

                      {/* <Divider orientation="vertical" flexItem sx={{ my: 1 }} /> */}

                      {/* <Button
                  variant={!viewLogs ? "outlined" : "contained"}
                  sx={{
                    // backgroundColor: "#154D8F",
                    textTransform: "none",
                    // "&:hover": { backgroundColor: "#1565c0" },
                  }}
                  onClick={viewAuditLogs}
                >
                  <Label text="Audit Trail" />
                </Button> */}
                      {/* Action Buttons */}
                      {((activeSection === "partial" && canDownloadPartialData) ||
                        (activeSection === "batches" && canDownloadBatches)) && <Box
                        sx={{
                          ml: 1,
                          mr: activeSection === "partial" ? 2 : 0,
                        }}
                      >
                        <Button
                          variant="contained"
                          startIcon={
                            (activeSection === "partial"
                              ? partialDownloadLoading
                              : downloadedBatchesData?.loader) ? (
                              <CircularProgress
                                size={16}
                                sx={{ color: "#fff" }}
                              />
                            ) : (
                              <DownloadIcon />
                            )
                          }
                          onClick={activeSection === "partial" ? handlePartialDownload : onClickDownload}
                          disabled={
                            activeSection === "partial"
                              ? partialDownloadLoading
                              : !!downloadedBatchesData?.loader
                          }
                          // disabled
                          sx={{ textTransform: "none", minHeight: "36px" }}
                        >
                          <Label
                            text={
                              (activeSection === "partial"
                                ? partialDownloadLoading
                                : downloadedBatchesData?.loader)
                                ? "Downloading"
                                : "Download"
                            }
                            color="#fff"
                          />
                        </Button>
                      </Box>}
                      {activeSection === "batches" && canDownloadBatches && (
                        <Box >
                          <Button
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            onClick={handleDownloadAll}
                            sx={{
                              textTransform: "none",
                              minHeight: "36px",
                              marginRight: 2,
                            }}
                          >
                            <Label text={"Download all"} color="#fff" />
                          </Button>
                        </Box>
                      )}
                      <Box
                        sx={{
                          ml: 2,
                          mr: "auto",
                          display: "flex",
                          gap: 1,
                          order: -1,
                          "& .MuiButton-root": { minHeight: "36px" },
                        }}
                      >
                        {canViewBatches && <Button
                          size="small"
                          variant={activeSection === "batches" ? "contained" : "outlined"}
                          onClick={() => {
                            if (
                              !unitOfOperation?.id &&
                              batchesListUnitOperation?.id
                            ) {
                              dispatch(
                                setProductSitesUopFilters({
                                  product,
                                  site,
                                  unitOfOperation: batchesListUnitOperation,
                                }),
                              );
                            }
                            setActiveSection("batches");
                            setViewLogs(false);
                          }}
                          sx={{ textTransform: "none" }}
                        >
                          Batches
                        </Button>}
                        {canViewPartialData && <Button
                          size="small"
                          variant={activeSection === "partial" ? "contained" : "outlined"}
                          onClick={() => {
                            setActiveSection("partial");
                            setPage(1);
                            if (
                              !selectedPartialUnitOperations.length &&
                              batchesListUnitOperation?.id
                            ) {
                              setSelectedPartialUnitOperations([
                                {
                                  id: batchesListUnitOperation.id,
                                  name: batchesListUnitOperation.name,
                                },
                              ]);
                              dispatch(
                                setProductSitesUopFilters({
                                  product,
                                  site,
                                  unitOfOperation: batchesListUnitOperation,
                                }),
                              );
                            }
                            setViewLogs(false);
                            setSelectedBatchIds([]);
                          }}
                          sx={{ textTransform: "none" }}
                        >
                          Partial Data
                        </Button>}
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        height: "calc(100vh - 245px)",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      {activeSection === "batches" ? (
                        <BatchesTable
                          batchesState={stableBatchesState}
                          loadingOverride={loader}
                          selectedBatchIds={selectedBatchIds}
                          onSelectionChange={setSelectedBatchIds}
                          handleViewDetails={handleViewDetails}
                          canViewMetaData={canViewMetaData}
                        />
                      ) : (
                        <PartialDataTable
                          rows={
                            selectedPartialUnitOperations.length
                              ? partialResults
                              : []
                          }
                          page={partialCurrentPage}
                          pageSize={partialPageSize}
                          loading={
                            selectedPartialUnitOperations.length > 0 &&
                            partialBatchesLoader
                          }
                          hasUnitOperation={
                            selectedPartialUnitOperations.length > 0
                          }
                          highlightedBatchId={
                            restoredPartialState?.highlightedBatchId
                          }
                          onBatchClick={handlePartialBatchClick}
                          sortConfig={partialSortConfig}
                          onSort={handlePartialSort}
                        />
                      )}
                      {((activeSection === "batches" && loader) ||
                        (activeSection === "partial" && partialBatchesLoader)) && (
                        <Loader />
                      )}
                      {!viewLogs && (
                        <Box sx={{ mt: 1 }}>
                          {
                            <Pagination
                              count={
                                activeSection === "partial" &&
                                !selectedPartialUnitOperations.length
                                  ? 1
                                  : totalPages
                              }
                              page={page}
                              onChange={(_e, val) => setPage(val)}
                            />
                          }
                        </Box>
                      )}
                    </Box>
                    {canDownloadBatches && <DownloadAll
                      open={downloadAll}
                      onClose={() => setDownloadAll(false)}
                      canDownload={canDownloadBatches}
                    />}
                  </>
                )}
              </Box>

              {/* Sticky Footer */}
            </Box>
          </Box>
        </Box>
      </InvestigatorContainer>

      {snackbar.open && (
        <CustomizedSnackbars
          severity={snackbar.severity}
          state={snackbar.open}
          text={snackbar.message}
          handleClose={() =>
            setSnackbar({ open: false, message: "", severity: "" })
          }
        />
      )}
    </div>
  );
};

export default Batches;
